// import "./styles/partials/_css-reset.scss";
import "./App.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import React from "react";
import Header from "./components/PageHeader/PageHeader";
import Upload from "./pages/Upload/Upload";
import Videos from "./pages/VideosPage/VideosPage";
import UploadSuccess from "./pages/UploadSuccess/UploadSuccess";
import PageNotFound from "./pages/PageNotFound/PageNotFound";

class App extends React.Component {
  render() {
    return (
      <Router>
        <Header />
        <Switch>
          <Route path="/" component={Videos} exact />
          <Route path="/videos" component={Videos} exact />
          <Route path="/videos/:id" component={Videos} />
          <Route path="/upload" component={Upload} />
          <Route path="/upload-success" component={UploadSuccess} />
          <Route path="/404" component={PageNotFound} />
          <Route component={PageNotFound} />
        </Switch>
      </Router>
    );
  }
}

export default App;
